



































































import { Component } from "vue-property-decorator";
import Vue from "vue";
import CardListPasien from "@/pages/DaftarPasienPage/CardListPasien.vue";
import DataSosialPasienCard from "@/pages/DaftarPasienPage/DataSosialPasienCard.vue";
import PasienKonsulanCard from "@/pages/DaftarPasienPage/PasienKonsulanCard.vue";
import PasienKonsulRujukInternalCard from "@/pages/DaftarPasienPage/PasienKonsulRujukInternalCard.vue";
import ListPasienTransferInternal from "@/components/pti/ListPasienTransferInternal.vue";
import CardPemeriksaan from "@/components/CardPemeriksaan.vue";
import DataPasien from "@/services/DataPasien";
import Pasien from "@/utility/Pasien";
import DataObject from "@/utility/DataObject";
import DataList from "@/services/DataList";
import { storeKonsul } from "@/store/modules/konsul";
import { isEmpty } from "lodash";
import { userModule } from "@/store/modules/user";
import { storeUnit } from "@/store/modules/unit";
import { storePasien } from "@/store/modules/pasien";
import { appModule } from "@/store/modules/app";
import { storeSoap } from "@/store/modules/soap";
import { storeCopy } from "@/store/modules/copy";
import { pusher } from "@/services/PusherClient";
import ConfirmDialog from "@/components/modal/ConfirmDialog.vue";
import moment from "moment";
import { storePerawat } from "@/store/modules/perawat";
import { storeDokter } from "@/store/modules/dokter";
import storeListPasienRalan from "@/store/modules/new/ListPasienRalan";
import ReferensiUnit from "@/store/modules/new/ReferensiUnit";
import { actingUnitQueryForListRow } from "@/utils/actingUnit";

@Component({
  components: {
    CardListPasien,
    DataSosialPasienCard,
    PasienKonsulanCard,
    CardPemeriksaan,
    ConfirmDialog,
    PasienKonsulRujukInternalCard,
    ListPasienTransferInternal
  },
  beforeRouteLeave(to, from, next) {
    pusher.unsubscribe(`pemeriksaan.unit.${this.sess_login["unit_id"]}`);
    storeListPasienRalan.CLEAR_ACTIVE_ROW();

    next();
  }
})
export default class DaftarPasien extends Vue {
  data: any = DataObject.dataSosial;
  titleCardPemeriksaan = "Ringkasan Pemeriksaan";
  btn = "";
  cm = "";
  today = moment().format("YYYY-MM-DD");
  private status: Array<object> = Pasien.status();
  // listDokter: Array<object> = [];
  // pasien: Array<object> = [];
  pasien: Array<any> = [];
  konsulan: Array<object> = [];
  hdn = "";
  loading = true;
  tabs: number;
  showFilterDokter = true;
  // loading2: boolean;
  errListPx = "0";
  errPx = "0";
  reg = "";
  sess_login = {};
  minDate = moment().format("YYYY-MM-DD");
  loadingDataPasien = false;
  loadingRmPasien = "";

  mounted() {
    const minn = new Date(new Date().setDate(new Date().getDate() - 7));
    this.minDate = moment(minn).format("YYYY-MM-DD");
    this.sess_login = this.stateuser;

    // this.getDokterByUnit(this.sess_login["unit_id"]);
    // storeUnit.act_on_all_pagi();

    storePasien.CLEAR_PASIEN();

    appModule.setLoading(true);

    if (!storeDokter.listOnKlinik.length) {
      storeDokter.act_dokter_all();
      storeDokter.act_on_unit(this.sess_login["unit_id"]);
    }

    if (!ReferensiUnit.unit.length) {
      ReferensiUnit.getUnit();
    }
  }

  get stateuser() {
    return userModule.user;
  }
  get showLoading() {
    return appModule.loading;
  }

  get statelistkonsul() {
    return storeKonsul.listKonsul;
  }

  get showKonsulanCard() {
    return true;
  }

  get showRingkasanPemeriksaanCard() {
    return this.stateuser.unit_group_id != "01";
  }

  get listPasienCardHeight() {
    return this.stateuser.unit_id != "01" ? "350" : "500";
  }

  selectStatus(value) {
    this.pasien = [];
    this.errListPx = "0";
    // console.log("val", value);
    // console.log('ses', this.sess_login['id'])
    let dr = "";
    if (
      this.sess_login["profesi"] == "Dokter" ||
      this.sess_login["profesi"] == "Psikolog"
    ) {
      if (isEmpty(value["dokter"])) {
        dr = this.sess_login["id"];
      } else if (value["dokter"] != this.sess_login["id"]) {
        dr = value["dokter"];
      }
    } else {
      // dr = "0";
      dr = value["dokter"];
    }

    // console.log('dr', dr)
    // appModule.setLoading(true);
    this.loading = true;
    // this.GetKonsulan(this.sess_login["unit_id"], value["dokter"]);
    this.GetKonsulan(this.sess_login["unit_id"], value["dokter"]);
    DataObject.filterCari.tanggal = value["tanggal"];
    DataObject.filterCari.status = value["status"];
    DataObject.filterCari.dokter = dr;
    // DataObject.filterCari.count = ComponentTanggal.;
    const dt = DataList.getListPasien(
      this.sess_login["unit_id"],
      value["tanggal"],
      value["status"],
      dr
    );
    dt.then(dt => {
      // console.log(dt);
      // appModule.setLoading(false);
      if (dt["status"] != 1) {
        this.errListPx = "1";
        // appModule.NoticeDelayAlert(dt.err);
        // appModule.sendErrorAlert(dt["err"]);
      } else {
        this.pasien = dt.data;
        this.data = DataObject.dataSosial;
        this.btn = "hidden";
        this.hdn = "";
        this.loading = false;
      }
    });
  }

  GetPasien() {
    this.pasien = [];
    let dr = "0";
    if (
      this.sess_login["profesi"] == "Dokter"
      // this.sess_login["profesi"] == "Psikolog"
    ) {
      dr = this.sess_login["id"];
      // this.showFilterDokter = true
      // } else {
      //   this.showFilterDokter = false
    } else {
      dr = "0";
    }
    this.loading = true;

    if (DataObject.filterCari.tanggal == "") {
      const dt = DataList.getListPasien(
        this.sess_login["unit_id"],
        this.today,
        "-1",
        dr
      );
      dt.then(dt => {
        appModule.setLoading(false);
        if (dt["status"] != 1) {
          this.errListPx = "1";
          // appModule.NoticeDelayAlert(dt.err);
          // appModule.sendErrorAlert(dt["err"]);
        } else {
          this.pasien = dt.data;
          this.btn = "hidden";
          this.hdn = "";
        }

        this.loading = false;
      });
    } else {
      this.today = DataObject.filterCari.tanggal;
      const dt = DataList.getListPasien(
        this.sess_login["unit_id"],
        DataObject.filterCari.tanggal,
        DataObject.filterCari.status,
        DataObject.filterCari.dokter
      );
      dt.then(dt => {
        appModule.setLoading(false);
        if (dt["status"] != 1) {
          this.errListPx = "1";
          // appModule.NoticeDelayAlert(dt.err);
          // appModule.sendErrorAlert(dt["err"]);
        } else {
          this.pasien = dt.data;
          this.btn = "hidden";
          this.hdn = "";
        }

        this.loading = false;
      });
    }

    // this.GetKonsulan(this.sess_login['unit_id'],'0')
    // this.getDokterByUnit(this.sess_login["unit_id"]);
    // this.getDokterByUnit(this.sess_login["unit_id"]);
  }

  GetKonsulan(kdPoli, kdDokter) {
    // const dt = DataList.getListPasienKonsulan(kdPoli,kdDokter)
    // dt.then(dt => {
    //   // this.konsulan = DataList.getListPasienKonsulan(kdPoli,kdDokter)
    //   this.konsulan = dt.data
    //   })
    const paramKonsul = {
      kdPoli: kdPoli,
      kdDokter: kdDokter,
      sort: "-created_at",
      tglStart: this.minDate,
      tglEnd: this.today
    };
    storeKonsul.act_on_list_konsul(paramKonsul);
  }

  getDokterByUnit(kdPoli) {
    storeDokter.act_on_unit(kdPoli);
  }
  get listDokter() {
    return storeDokter.list;
  }
  // getDokterByUnit(kdPoli) {
  //   const dktr = DataDokter.getListDokterByPoli(kdPoli);
  //   dktr.then(dktr => {
  //     this.listDokter = dktr;
  //   });
  // }

  dataPasien(value) {
    this.errPx = "0";
    // console.log("val", value["item"]);
    // console.log("loaded", value["item"].loaded);
    // value["item"].loading2 = true;
    this.data = DataObject.dataSosial;
    this.hdn = "";
    this.btn = "hidden";
    // appModule.setLoading(true);
    this.loadingDataPasien = true;
    this.loadingRmPasien = value.item.rm;

    const dt = DataPasien.getDetailPemeriksaan(value["item"].register_id);
    dt.then(dt => {
      // console.log(dt);
      if (dt["status"] != 1) {
        // appModule.NoticeDelayAlert(dt.err);
        this.errPx = "1";
        this.reg = value["item"].register_id;
        // appModule.sendErrorAlert(dt["err"]);
      } else {
        // this.data = dt.data;

        // start testing for reghf
        dt.data.pasien.is_reg_heart_failure = value.item.is_reg_heart_failure;
        this.data = dt.data;
        // end of testing for reghf

        this.btn = "";
        this.cm = value["item"].rm;
        this.hdn = "1";
        // this.loading2 = value["item"].loaded;

        const pasien = { ...dt["data"].alergi };
        pasien.alergi = dt["data"].alergi;

        storePasien.setRegisterPasien({
          register: dt.data.register, // eslint-disable-line
          pasien: pasien
        });
        storePasien.setPasien(pasien);
      }

      // value["item"].loaded = false;
    }).finally(() => {
      this.loadingDataPasien = false;
      this.loadingRmPasien = "";
    });

    storePasien.act_pasien(value.item.rm);
  }

  addSoap(val) {
    const dt = DataPasien.getDataPasienLastReg(val["rm"]);
    dt.then(dt => {
      // console.log(dt);
      if (dt["status"] != 1) {
        // appModule.sendErrorAlert(dt["err"]);
      } else {
        storeCopy.clear_copy_all();
        storeSoap.act_clear_ctt();
        this.$router.push({
          name: `pemeriksaan`,
          params: {
            register: val["register"],
            rm: val["rm"],
            page: val["page"]
            // rm: this.data["pasien"].rm,
          },
          query: this.queryUnitSegmen(val["register"])
        });
      }
    });
    // console.log(val);
    // storeCopy.clear_copy_all();
    // storeSoap.act_clear_ctt();
    // this.$router.push({
    //   name: `pemeriksaan`,
    //   params: {
    //     register: val["register"],
    //     rm: val["rm"],
    //     page: val["page"],
    //     // rm: this.data["pasien"].rm,
    //   },
    // });
  }

  pageResep(val) {
    const dt = DataPasien.getDataPasienLastReg(val["rm"]);
    dt.then(dt => {
      if (dt["status"] != 1) {
        // appModule.sendErrorAlert(dt["err"]);
      } else {
        storeCopy.clear_copy_all();
        storeSoap.act_clear_ctt();
        this.$router.push({
          name: `pemeriksaan`,
          params: {
            register: val["register"],
            rm: val["rm"],
            page: val["page"]
            // rm: this.data["pasien"].rm,
          },
          query: this.queryUnitSegmen(val["register"])
        });
      }
    });
  }

  get statekonsul() {
    return storeKonsul.konsul;
  }

  jwbKonsul(val) {
    this.$router.push({
      name: `pemeriksaan`,
      params: {
        register: val[0],
        page: val[1],
        rm: val[2]
      },
      query: this.queryUnitSegmen(val[0])
    });
  }

  queryUnitSegmen(register): Record<string, string> {
    const baris = storeListPasienRalan.list.find(
      (item: any) => String(item.register_id) === String(register)
    );

    return actingUnitQueryForListRow(baris);
  }

  reloadPx() {
    const register = { item: { register_id: this.reg } };
    this.errPx = "0";
    // console.log(register);
    this.dataPasien(register);
  }

  reloadPage() {
    location.reload();
  }
}
